/** @jsxImportSource @emotion/react */
import { TableRow } from "../../../components/table-components/TableRow";
import { IntegrationListItem } from "../models/integrations";
import { TableCellText } from "../../../components/table-components/TableCellText";
import { StyledText } from "../../../assets/typography/typography";
import { css } from "@emotion/react";
import { Avatar } from "../../../components/Avatar";
import { colors } from "../../../components/colors";
import { IntegrationListItemDropdown } from "./IntegrationListItemDropdown";
import { useSearchParamsManipulation } from "../../../hooks/use-searchparams-manipulation";

type Props = {
  integration: IntegrationListItem;
};

const platformWrapperStyle = css`
  display: flex;
  flex-direction: row;
  gap: 16px;
  align-items: center;
`;

const dropdownWrapperStyle = css`
  display: flex;
  align-items: center;
  height: 100%;
  flex-direction: row;
  gap: 8px;
  justify-content: end;
`;

const getFile = (platform: string) => {
  switch (platform) {
    case "Foodora":
      return require("../../../assets/images/FoodoraLogo.png");
    case "JET":
      return require("../../../assets/images/JustEatLogo.png");
    case "Wolt":
      return require("../../../assets/images/WoltLogo.jpeg");
    default:
      return undefined;
  }
};

export const IntegrationsListTableRow = ({ integration }: Props) => {
  const { setOption } = useSearchParamsManipulation();

  return (
    <>
      <TableRow onClick={() => setOption(integration.id)}>
        <TableCellText className="pl-5">
          <div css={platformWrapperStyle}>
            <Avatar file={getFile(integration.platform)} size="medium">
              {integration.platform.charAt(0).toUpperCase()}
            </Avatar>
            <StyledText
              color={colors.textPrimary}
              className="bodyTextRegular mb-0"
            >
              {integration.platform}
            </StyledText>
          </div>
        </TableCellText>
        <TableCellText>
          <StyledText
            color={colors.textPrimary}
            className="bodyTextRegular mb-0"
          >
            {integration.name}
          </StyledText>
        </TableCellText>
        <td css={dropdownWrapperStyle}>
          <IntegrationListItemDropdown id={integration.id} />
        </td>
      </TableRow>
    </>
  );
};
